module.exports = __webpack_public_path__ + "static/media/042-aruba.ac9a9d62.svg";